module.exports = __webpack_public_path__ + "static/media/cw.4271644c.svg";